// extracted by mini-css-extract-plugin
export default {"form__inner":"Input_form__inner__duRtW","form__inner__input":"Input_form__inner__input__uMMhV","invalid":"Input_invalid__C9zOx","invalidInput":"Input_invalidInput__c6CwR"};